import * as Yup from 'yup';

export const initialValues = {
    dynamicConversationMemory: [
        { value: 'Recuerda el nombre del usuario y úsalo en la conversación.' },
        {
            value: 'Si el usuario ha preguntado algo antes, evita repetir la misma explicación.',
        },
        {
            value: 'Si la consulta es recurrente, sugerir fuentes de autoayuda o recursos.',
        },
    ],
};

export const validationSchema = Yup.object().shape({
    dynamicConversationMemory: Yup.array().of(
        Yup.object().shape({
            value: Yup.string().required('Requerido'),
        })
    ),
});
